// c:description*
class WorkerEventDispatcher {
  // c:constructor*
  constructor(opts) {
    this.worker = opts.worker
    this.receivers = opts.receivers
    // this.graphBus = opts.graphBus
    this.worker.onmessage = this.onMessageDispatch.bind(this)
  }

  // c:onMessageDispatch*
  onMessageDispatch(opts) {
    const data = opts.data
    const receiver = this.receivers[data.eventType]
    if (receiver && receiver != null) {
      if (typeof receiver.write === 'function') { //handle writable streams
        receiver.write(data.message)
      } else if (typeof receiver.push === 'function') { //handle kefir streams
        receiver.push(data.message)
      } else if (typeof receiver.emit === 'function') { //handle event emitters
        receiver.emit(data.eventName, data.message)
      } else {
        console.error("No valid receiver method found:", data)
      }
    } else {
      console.error("No receiver for message:", data)
    }
  }

  // c:setWorker*
  setWorker(worker) {
    this.worker.onmessage = null
    this.worker = worker
    this.worker.onmessage = this.onMessageDispatch.bind(this)
  }
}

export default WorkerEventDispatcher
